import React from 'react';
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { LogOut, Info } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const AppHeader = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/auth');
  };

  return (
    <header className="app-header">
      <Separator className="w-full bg-gray-200 mb-4" />
      <div className="flex items-center justify-between px-4">
        <div className="flex items-center justify-center gap-3">
          <div>
            <h1 className="font-title text-4xl font-bold text-financial-accent">
              UNI-Connect
            </h1>
            <p className="text-gray-600 text-lg font-title mt-1">
              Connect transaction lines to categories in the finance dashboard, based on account, team and project ranges
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/about')}
            className="flex items-center gap-2"
          >
            <Info className="h-4 w-4" />
            About
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handleSignOut}
            className="flex items-center gap-2"
          >
            <LogOut className="h-4 w-4" />
            Sign Out
          </Button>
          <img 
            src="/lovable-uploads/a335c3cc-3046-4fb8-98c3-1af91b85f3aa.png" 
            alt="Beeminds Logo" 
            className="h-8 w-auto"
          />
        </div>
      </div>
      <Separator className="w-full bg-gray-200 mt-4 mb-4" />
    </header>
  );
};